<template>
	<div>
		<div class="display-1 font-weight-light mb-3">Transactions</div>
		<timezone />
		<v-form>
			<v-row>
				<v-col>
					<v-text-field persistent-hint clearable  label="Tracking #" v-model="search.trackingNumber" v-on:keyup.enter="refresh"></v-text-field>
				</v-col>
				<v-col>
					<v-select persistent-hint clearable v-model="search.status" label="Status" :items="config.lists.statusOptions"></v-select>
				</v-col>
<!--				<v-flex mr-3>-->
<!--					<v-select persistent-hint clearable v-model="search.region" label="Region" :items="config.lists.requestRegions"></v-select>-->
<!--				</v-flex>-->
				<v-col>
					<v-select persistent-hint clearable v-model="search.customer" label="Customers" :items="config.lists.customers"></v-select>
				</v-col>
				<v-col>
					<v-select persistent-hint clearable v-model="search.applicationId" label="Application" :items="config.lists.applications" item-text="name" item-value="id"></v-select>
				</v-col>
			</v-row>
			<v-row>
				<v-col>
					<v-text-field persistent-hint clearable label="Device Id" v-model="search.deviceId" v-on:keyup.enter="refresh"></v-text-field>
				</v-col>
				<v-col>
					<v-select persistent-hint clearable v-model="search.partnerId" label="Partner" :items="config.lists.partners" item-text="key" item-value="value"></v-select>
				</v-col>
				<v-col>
					<v-select persistent-hint clearable v-model="search.transactionType" label="Type" :items="['Analysis', 'Pkg', 'Snapshot', 'Report']"></v-select>
				</v-col>
				<v-col>
					<v-menu
						v-model="menuStart"
						:close-on-content-click="false"
						:nudge-right="40"
						transition="scale-transition"
						offset-y
						min-width="290px"
					>
						<template v-slot:activator="{ on }">
							<v-text-field
								v-model="search.startDate"
								label="Range Start"
								prepend-icon="fal fa-calendar-alt fa-sm"
								readonly
								v-on="on"
							></v-text-field>
						</template>
						<v-date-picker v-model="search.startDate" @input="menuStart = false"></v-date-picker>
					</v-menu>
				</v-col>
				<v-col>
					<v-menu
						v-model="menuEnd"
						:close-on-content-click="false"
						:nudge-right="40"
						transition="scale-transition"
						offset-y
						min-width="290px"
					>
						<template v-slot:activator="{ on }">
							<v-text-field
								v-model="search.endDate"
								label="Range End"
								prepend-icon="fal fa-calendar-alt fa-sm"
								readonly
								v-on="on"
							></v-text-field>
						</template>
						<v-date-picker v-model="search.endDate" @input="menuEnd = false"></v-date-picker>
					</v-menu>
				</v-col>
			</v-row>
		</v-form>

		<v-row class="mb-5" >
			<v-col>
				<v-btn color="success" :loading="loading" @click="refresh" class="mr-3"><v-icon small>far fa-search fa-fw</v-icon> Search</v-btn>
				<v-btn @click="reset">Reset</v-btn>
			</v-col>
		</v-row>

		<v-row  class="table-key mb-2 pl-3">
			<v-col class="mr-1 shrink" ><transaction-type type="Analysis" /> Analysis</v-col>
			<v-col class="mr-1 shrink" ><transaction-type type="Pkg" /> Pkg</v-col>
			<v-col class="mr-1 shrink" ><transaction-type type="Snapshot" /> Snapshot</v-col>
			<v-col class="grow" ><transaction-type type="Report" /> Report</v-col>
		</v-row>

		<v-data-table :items="transactions" :headers="headers" :loading="loading" item-key="id" sort-by=""
			no-data-text="No entries" class="transactions-table tight" :items-per-page.sync="rowsPerPage">
			<template v-slot:item="props">
				<tr>
					<td><transaction-type :type="props.item.transactionType" /> {{props.item.id}}</td>
					<td>{{formatDateTime(dt(props.item.created))}} <small v-html="queuedTime(props.item)"></small></td>
					<td><tracking :number="props.item.trackingNumber" @clicked="trackClick" /></td>
	<!--				<td>{{props.item.region}}</td>-->
	<!--				<td><status :value="props.item.status" :id="props.item.trackingNumber"></status></td>-->
					<td>{{props.item.status}}</td>
					<td :class="{'not-active': !props.item.applicationActive}">{{props.item.application}}</td>
					<td>{{props.item.customer}}</td>
					<td :class="{'not-active': !props.item.partnerActive}">{{props.item.partner}}</td>
					<td>{{props.item.deviceId}}</td>
					<td>{{msToHM(props.item.fileLengthMS)}}</td>
				</tr>
			</template>
			<template v-slot:pageText="props">
				{{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }} <strong v-if="results" class="pl-3">{{results}}</strong>
			</template>
		</v-data-table>

		<v-alert mt-5 type="error" v-model="notFound" dismissible>
			Request Not Found: <span class="code">{{viewId}}</span>
		</v-alert>

		<v-progress-linear :indeterminate="true" v-if="loadingTransaction"></v-progress-linear>

		<v-row class="mt-5" v-if="request">
			<v-col>
				<transaction-info :request="request" :transaction="transaction" @close="closeRequest" @view="trackClick"></transaction-info>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import { findIndex } from "lodash";
import { seconds, msToHM } from "../utils";
import { transactionStatus } from "../enums";
import tracking from "../components/tracking-number.vue";
import transactionType from "../components/transactions/transaction-type.vue";
import TransactionInfo from "../components/transactions/transaction-info.vue";
import timezone	from "../components/timezone.vue";
// import status from "./components/status.vue";
import api from "../api";

export default {
	components: {
		tracking,
		transactionType,
		// status,
		TransactionInfo,
		timezone,
	},
	data() {
		return {
			headers: [
				{ text: "Type", value: "id", sortable: false },
				{ text: "Queued (wait)", value: "created", sortable: false },
				{ text: "Tracking #", value: "trackingNumber", sortable: false },
				// { text: "Region", value: "region", sortable: false },
				{ text: "Status", value: "status", sortable: false },
				{ text: "Application", value: "application", sortable: false },
				{ text: "Customer", value: "customer", sortable: false },
				{ text: "Partner", value: "partner", sortable: false },
				{ text: "Device", value: "device", sortable: false },
				{ text: "Duration (HH:MM)", value: "duration", sortable: false },
			],
			transactions: [],
			recordCount: null,
			loading: true,
			confirming: false,
			search: {
				userId: null,
				applicationId: null,
				partnerId: null,
				region: null,
				customer: null,
				status: null,
				startDate: this.dtnow().minus({ months: 1 }).toFormat("yyyy-MM-dd"),
				endDate: this.dtnow().toFormat("yyyy-MM-dd"),
				transactionType: null,
				trackingNumber: null, //"88d99097",
				deviceId: null,
				offset: 0,
			},
			menuStart: false,
			menuEnd: false,
			searchDefault: {},
			viewId: null,
			request: null,
			notFound: false,
			rowsPerPage: 10,
			page: 1,
			previousPagination: 10,
			loadingTransaction: false,
		};
	},
	created() {
		this.searchDefault = Object.assign({}, this.search);

		this.refresh();
	},
	computed: {
		results() {
			if (!this.recordCount) {
				return "";
			}

			return this.recordCount >= 100 ? `(${this.recordCount} total)` : "";
		},
		transaction() {
			return this.transactions.find(t => t.trackingNumber === this.viewId);
		},
	},
	methods: {
		msToHM,
		queuedTime(item) {
			if (item.status !== transactionStatus.Completed) {
				return "";
			}

			return seconds(this.dt(item.created), this.dt(item.jobStarted), "<br>( # )");
		},
		trackClick(id) {
			// set pagination to 5 and page to the item
			this.previousPagination = this.rowsPerPage;
			this.rowsPerPage = 5;
			this.page = findIndex(this.transactions, t => t.trackingNumber === id) % 5;

			this.notFound = false;
			this.viewId = id;
			this.loadingTransaction = true;
			this.request = null;

			api.transactionRequest(id).then((r) => {
				this.request = r.data;

				this.notFound = this.request.notFound;
				this.loadingTransaction = false;

				this.$nextTick(() => {
					document.getElementById("request-details").scrollIntoView();
				});
			}, (e) => {
				this.showError(e);
				this.loadingTransaction = false;
			});
		},
		refresh() {
			this.loading = true;
			this.viewId = null;
			this.request = null;

			this.search.offset = this.dtnow().offset;

			api.transactions(this.search).then((r) => {
				this.transactions = r.data.results;
				this.recordCount = r.data.total;
				this.loading = false;
			}, (e) => {
				this.showError(e);
				this.loading = false;
			});
		},
		reset() {
			this.search = Object.assign({}, this.searchDefault);

			this.refresh();
		},
		closeRequest() {
			this.request = null;
			this.viewId = null;
			this.rowsPerPage = this.previousPagination;
		},
	},
};
</script>
